import { atom } from "recoil";


const SearchMenuAtom = atom({
    default: false,
    key: 'searchMenuAtom'
})

export default SearchMenuAtom;